import React from 'react';
import logo from '../../images/logo-w.png';
import {useTranslation } from "react-i18next"; 

function Contact() {
    const { t, i18n } = useTranslation();
    return (
        <section id="contact" className="contact">
            <div className="container" >
                <div className="section-title">
                    <h2>Contact</h2>
                    <p>{t("contact-us")}</p>
                </div>
            </div>        
            <div className="container d-flex justify-content-center" >
                <div className="row">                                    
                    <div className="col-sm-6 pb-3 px-5">
                        <div className="info">
                            <div className="address">
                                <i className="fas fa-map-marker-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter3"></i>
                                <h4>{t("our-location")}</h4>
                                <p> Nieuwstraat 20, Asse - 1730</p>
                            </div>
                            <div className="open-hours">
                                <i className="no-pointer fas fa-calendar-alt"></i>
                                <h4>{t("openings-hours")}</h4>
                                <p>
                                {t("tuesday-saturday")}<br></br>
                                11:30 AM - 00:00 PM<br></br>
                                {t("sunday")}<br></br>
                                09:00 AM - 00:00 PM<br></br>
                                {t("closed-monday")}                                
                                </p>
                            </div>
                            <div className="email">
                                <i className="fa fa-envelope" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2"></i>
                                <h4>Email</h4>
                                <p> info@oldtbilisi.be</p>
                            </div>
                            <div className="phone">
                                <i className="fas fa-phone-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter"></i>
                                <h4>{t("call-us")}</h4>
                                <p>+32 2 502 17 29</p>
                            </div>                
                        </div>
                    </div>
                    <div className="center col-sm-6">
                        <img className="logo-contact img-fluid" src={logo} alt="Old Tbilisi"/>
                    </div>  
                    <div className="col-lg-8 mt-3">
                        <div className="section-title">
                            <h2>{t("send-us-a-message")}</h2>              
                        </div>
                        <form action="https://formsubmit.co/info@oldtbilisi.be" method="POST">
                            <input type="hidden" name="_subject" value={t("new-message")}/>
                            <input type="hidden" name="_captcha" value="false"/>
                            <div className="form-row">
                                <div className="col-md-6 form-group">
                                    <input type="text" name="name" className="form-control" id="name" placeholder={t("your-name")} required/>                          
                                </div>
                                <div className="col-md-6 form-group">
                                    <input type="email" className="form-control" name="email" id="email" placeholder={t("your-email")} required/>                         
                                </div>
                            </div>        
                            <div className="form-group">
                                <input type="text" className="form-control" name="subject" id="subject" placeholder={t("subject")} required />                      
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" name="message" rows="4" placeholder={t("contact-message")} required></textarea>                      
                            </div>                        
                            <div className="text-center pt-3"><button type="submit">{t("send-message")}</button></div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact;
